<template>
    <div class="section-member-node">
        <TreeNode
            height="auto"
            :showExpand="false"
            :showExpandIcon="false"
            :checked="checked"
            @handleChecked="handleChecked">
            <template slot="content">
                <div class="section-member-node-content">
                    <Avatar 
                        size="32px"
                        fontSize="12px"
                        :name="data.userName || data.name"
                        :memberId="data.memberId"
                        :path="data.avatar"/>
                    <div class="section-member-node-info">
                        <div class="section-member-node-name">{{data.userName || data.name}}</div>
                        <div class="section-member-node-dept">{{data.deptName}}</div>
                    </div>
                </div>
            </template>
        </TreeNode>
    </div>
</template>
<script>
    import Avatar from '../../../base/avatar/'
    import node from '../mixins/node'
    export default {
        name: 'MemberNode',
        inject: ['root'],
        mixins: [node],
        props: {
            data: {
                type: Object,
                default () {
                    return {}
                }
            },
            parent: {
                type: Object
            }
        },
        computed: {
            checked() {
                const data = this.root.selected.member[this.data.memberId] || null
                this.data.checked = !!data // 重置当前选择状态
                return !!data
            }
        },
        components: {
            Avatar
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/business/select-member/section/section-member-node.vue